import { Allowance } from '@/interfaces/allowances';
import { queryAllowance } from '@/services/allowances.service';
import { Effect, Reducer } from '@umijs/max';
import { redirectNotFound } from '@/utils/errorRedirect';

export interface StateType {
  allowance: Allowance | null;
}

export interface ModelType {
  namespace: string;
  state: StateType;
  effects: {
    fetch: Effect;
    updateAllowance: Effect;
  };
  reducers: {
    saveData: Reducer<StateType>;
  };
}

const Model: ModelType = {
  namespace: 'allowanceDetails',

  state: {
    allowance: null,
  },

  effects: {
    *fetch({ payload }, { call, put, all }) {
      try {
        const [allowance] = yield all([call(queryAllowance, payload)]);
        
        yield put({
          type: 'saveData',
          payload: { allowance: allowance.data },
        });
      } catch (error) {
        redirectNotFound(error);
      }
    },

    *updateAllowance({ payload }, { put }) {
      yield put({
        type: 'saveData',
        payload,
      });
    },
  },

  reducers: {
    saveData(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};

export default Model;
